class Cartdiscount extends HTMLElement {
  constructor() {
    super();

    this.coupon_button = this.querySelector('.cart-trigger');
    this.cart_content = this.querySelector('.cart-content');
    this.cartDrawerCheckoutButton = document.querySelector('#CartDrawer-Checkout');
    this.submit_button = this.querySelector('.cart-btn');
    this.discount_value = this.querySelector('input');

    this.active = false;

    this.init();
  }

  init() {
    this.coupon_button.addEventListener('click', (event) => {
      event.preventDefault();
      if (!this.active) { this.activeState(); this.active = true; } else { this.hideState(); this.active = false; }
    });
    this.submit_button.addEventListener('click', (event) => {
      event.preventDefault();
      this.submit_button.textContent = "Loading...";
      this.fetchCode(this.discount_value.value);
    })
  }

  fetchCode(value) {
    this.cartDrawerCheckoutButton.disabled = true;
    fetch(`/discount/${value}`).then(async (response) => {

      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer', 'discount-code'];

          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);

            if (targetElement && sourceElement) {
              if (selector === 'discount-code') {
                sourceElement.classList.add('ajax-class-loaded');
              }
              targetElement.replaceWith(sourceElement);
            }
          }
          this.getDiscountMessage(value);

          setTimeout(function () {
            const discountCodeElement = document.querySelector('discount-code');
            if (discountCodeElement && discountCodeElement.classList.contains('ajax-class-loaded')) {
              discountCodeElement.classList.remove('ajax-class-loaded');
            }
          }, 5000);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.cartDrawerCheckoutButton.disabled = false;
        });
    });
  }

  getDiscountMessage(code) {
    let error_container = document.querySelector('.no-manual-discount');
    if (error_container != null) {
      let message = window.ferg_discount_error_msg.find(d => d.discount === "default").message;  // Set default message

      window.ferg_discount_error_msg.forEach(discountObj => {
        if (discountObj.discount === code) {
          message = discountObj.message;
        }
      });
      error_container.innerHTML = message;

      return message;
    }
  }

  activeState() {
    this.cart_content.classList.add('active');
    this.coupon_button.classList.add('active');
  }

  hideState() {
    this.cart_content.classList.remove('active');
    this.coupon_button.classList.remove('active');
    this.discount_value.value = '';
  }
}

customElements.define('discount-code', Cartdiscount);


// cart-checkbox-products.js
class CartCheckboxProducts extends HTMLElement {
  constructor() {
    super();

    this.checkbox = this.querySelector('input[type="checkbox"]'); // Declare as a class property
    this.isLoading = false; // Add a flag to track if a request is in progress
    this.cartDrawerCheckoutButton = document.querySelector('#CartDrawer-Checkout'); // Get the CartDrawer-Checkout button
    this.freeProductAndGifts = new FreeProductAndGifts();
    this.init();
  }

  init() {
    this.checkbox.addEventListener('change', (event) => {
      if (this.isLoading) return; // If a request is in progress, do nothing
      let id = event.target.id;
      if (event.target.checked) {
        this.addProduct(id);
      } else {
        this.removeProduct(id);
      }
    });

  }

  addProduct(variantId) {
    this.isLoading = true; // Set the flag to true when a request starts
    this.cartDrawerCheckoutButton.disabled = true; // Disable the CartDrawer-Checkout button
    let formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        } else {
          return response.json();
        }
      })
      .then(data => {
        this.onCartUpdate();
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        this.isLoading = false; // Set the flag to false when the request is complete
        this.cartDrawerCheckoutButton.disabled = false; // Enable the CartDrawer-Checkout button
      });
  }

  removeProduct(variantId) {
    this.isLoading = true; // Set the flag to true when a request starts
    this.cartDrawerCheckoutButton.disabled = true; // Disable the CartDrawer-Checkout button
    let data = {
      "id": variantId,
      "quantity": 0
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        } else {
          return response.json();
        }
      })
      .then(data => {
        if (data.item_count == 0) {
          document.querySelector('cart-drawer').classList.add('is-empty')
          window.carting_checkbox_checked = false;
        }
        this.onCartUpdate();
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        this.isLoading = false; // Set the flag to false when the request is complete
        this.cartDrawerCheckoutButton.disabled = false; // Enable the CartDrawer-Checkout button
      });
  }

  onCartUpdate() {
    this.freeProductAndGifts.checkFreeProductAndGifts();
  }
}

customElements.define('cart-checkbox-products', CartCheckboxProducts);
